import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { PageableTableComponent } from '../../../../shared/controls/pageable-table/pageable-table.component';

import { InitializerService } from '../../../../shared/services/initializer-service';
import { ErrorService } from '../../../../shared/services/error-service';

import { AuditResponseService, FilteredAuditResponseItem, PagingData } from '../../../../../service/proxy';

@Component({
    selector: 'app-audit-response',
    templateUrl: './audit-response.component.html',
    styleUrls: ['./audit-response.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        PageableTableComponent,
    ],

    providers: [
        AuditResponseService,
    ]
})
export class AuditResponseComponent implements OnInit {
    public search: string = '';
    public paging: PagingData = new PagingData();
    public auditResponses:  FilteredAuditResponseItem[] = [];
    public requestId: string = '';
    public auditResponse: any = {};

    constructor(
        private route: ActivatedRoute,
        private auditResponseService: AuditResponseService,
        private initializerService: InitializerService,
        private errorService: ErrorService)
        {
            this.paging = this.initializerService.createPagingData();
        }

    ngOnInit(): void {
        this.requestId = this.route.snapshot.paramMap.get('id') || '';

        if (this.requestId) {
            this.getAuditResponses(this.paging);
        }
    }

    refreshGridData(): void {
        this.paging = this.initializerService.createPagingData();
        this.getAuditResponses(this.paging);
    }

   getAuditResponses(pagingData: PagingData): void {
        if (this.requestId) {
            (this.auditResponseService.getFilteredAuditResponses as any)(
                this.search,
                pagingData.pageNo,
                pagingData.pageSize,
                pagingData.sortDirection,
                pagingData.sortColumn,
                this.requestId
            ).subscribe({
                next: (data: any) => {
                    this.paging = data.pagingData;
                    this.auditResponses = data.results || [];
                },
                error: (error: any) => {
                    if (error.status === 204) {
                        this.auditResponses = [];
                        this.paging = this.initializerService.createPagingData();
                    }
                    else {
                        this.errorService.handleError(error);
                    }
                }
            });
        }
    }

    getColumnMap() {
        return {
            requestId: 'Request Id',
            status: 'Status',
            contentType: 'Content Type',
            createdAt: 'Created At',
        };
    }
}